import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';

// Public: a new joiner opens the emailed link and sets their password.

const box = { maxWidth: 420, margin: '4rem auto', padding: 28, borderRadius: 12, background: 'var(--card-bg, var(--surface))', border: '1px solid var(--border)', color: 'var(--text-main)' };
const input = { width: '100%', padding: '10px 12px', border: '1px solid var(--input-border, var(--border))', borderRadius: 8, fontSize: 15, background: 'var(--input-bg, var(--surface))', color: 'var(--text-main)', boxSizing: 'border-box' };

const InviteAccept = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [invite, setInvite] = useState(null);
    const [error, setError] = useState(null);
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        api.get(`/auth/invite/${encodeURIComponent(token)}`)
            .then(r => setInvite(r.data))
            .catch(e => setError(e.response?.data?.error || 'This link does not work. Ask HR for a new one.'));
    }, [token]);

    const submit = async (e) => {
        e.preventDefault();
        if (password.length < 8) { setError('Choose a password of at least 8 characters'); return; }
        if (password !== confirm) { setError('The two passwords do not match'); return; }
        setBusy(true);
        try {
            const r = await api.post('/auth/invite/accept', { token, password });
            navigate(`/login?welcome=1&email=${encodeURIComponent(r.data.email)}`);
        } catch (err) {
            setError(err.response?.data?.error || 'Could not set your password');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', background: 'var(--bg, var(--background))', padding: '0 16px' }}>
            <div style={box}>
                {!invite && !error && <p>Checking your link…</p>}
                {!invite && error && <><h1 style={{ fontSize: 22 }}>Link not valid</h1><p role="alert">{error}</p><p>Already set your password? <a href="/login">Sign in</a>.</p></>}
                {invite && (
                    <form onSubmit={submit} style={{ display: 'grid', gap: 14 }}>
                        <h1 style={{ fontSize: 22, margin: 0 }}>Welcome, {invite.name}</h1>
                        <p style={{ margin: 0, color: 'var(--text-muted)' }}>Choose a password. You'll sign in with <strong>{invite.email}</strong>.</p>
                        <label style={{ display: 'grid', gap: 6 }}>New password
                            <input type="password" autoComplete="new-password" style={input} value={password} onChange={e => setPassword(e.target.value)} />
                        </label>
                        <label style={{ display: 'grid', gap: 6 }}>Type it again
                            <input type="password" autoComplete="new-password" style={input} value={confirm} onChange={e => setConfirm(e.target.value)} />
                        </label>
                        {error && <p role="alert" style={{ color: '#ef4444', margin: 0 }}>{error}</p>}
                        <button className="btn btn-primary" disabled={busy} style={{ padding: '10px 16px' }}>{busy ? 'Saving…' : 'Set password'}</button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default InviteAccept;
